"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 6.5C2 7.33 2.67 8 3.5 8H8v2.5H4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H8V16H3.5c-.83 0-1.5.67-1.5 1.5S2.67 19 3.5 19H8c1.66 0 3-1.34 3-3v-1.9c0-1.16-.94-2.1-2.1-2.1 1.16 0 2.1-.94 2.1-2.1V8c0-1.66-1.34-3-3-3H3.5C2.67 5 2 5.67 2 6.5M19 8v8h-4V8zm0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3"
}), 'ThirtyFpsRounded');